<template>
 <b-container fluid>
   <b-row class="mt-4">
      <b-col class="col-md-auto col-sm-2">
        <h2 class="text-left">My Courses</h2>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <b-col>
        <b-input-group>
          <b-form-input
            v-model="searchText"
            placeholder="Search"
            type="text"
            debounce="500">
          </b-form-input>
          <b-input-group-append>
            <b-button v-on:click="searchText= ''"><b-icon-x></b-icon-x></b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col></b-col>
      <b-col class="text-right col-md-auto">
        <b-pagination v-model="pagination.page" :total-rows="pagination.total" :per-page="pagination.pageSize" align="right" v-if="!loading" @change="filterData"></b-pagination>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <b-spinner v-if="loading" variant="primary"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-if="!loading" class="mt-1">
      <b-col>
        <course-card v-for="c in courses" :key="c.course.id" :course="c.course" :type="c.type"></course-card>
        <h3 v-if="courses.length === 0">You have not enrolled in any courses.</h3>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Api from '@/api/Api'
import CourseCard from './components/CourseCard'

export default {
  name: 'PastCoursesPage',
  data () {
    return {
      loading: false,
      courses: [],
      searchText: '',
      pagination: {
        pageSize: 10,
        page: 1,
        total: 0
      }
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.auth.currentUser
    }
  },
  created () {
    this.filterData(1)
  },
  methods: {
    filterData (page) {
      var vm = this
      vm.loading = true
      vm.pagination.page = page
      Api().get(`Users/Courses?page=${vm.pagination.page}&pageSize=${vm.pagination.pageSize}&search=${vm.searchText}`)
        .then((r) => {
          vm.courses = r.data.items
          vm.pagination.total = r.data.total
          vm.pagination.pageSize = r.data.pageSize
        })
        .catch((e) => {
          if (e.response.status === 401) {
            this.$router.push({ name: 'Login' })
          } else {
            console.log(e)
          }
        })
        .finally(() => {
          vm.loading = false
        })
    }
  },
  watch: {
    searchText (value) {
      this.searchText = value
      this.filterData(1)
    }
  },
  components: {
    CourseCard
  }
}
</script>
